import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon,
  Stack,
} from "@chakra-ui/react";
import * as React from "react";
import {
  getUserHandleError,
  USER_HANDLE_MAX_LENGTH,
  USER_HANDLE_MIN_LENGTH,
} from "../../../../core/userHandle";

export const SignupForm = (props) => {
  const [userHandle, setUserHandle] = React.useState("");
  const [error, setError] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleUsernameChange = (nextValue) => {
    setUserHandle(nextValue);
    setError(getUserHandleError(nextValue));
  };

  return (
    <form
      method="POST"
      onSubmit={(e) => {
        e.preventDefault();
        const userHandleError = getUserHandleError(userHandle);
        setError(userHandleError);

        if (userHandleError) {
          return;
        }

        props.onSubmit({
          firstName: "User",
          lastName: "@",
          email,
          password,
          userHandle,
        });
      }}
    >
      <Stack spacing="6">
        <FormControl isInvalid={error !== ""}>
          <FormLabel>User handle</FormLabel>
          <InputGroup>
            <InputLeftAddon>@</InputLeftAddon>
            <Input
              value={userHandle}
              label="User handle"
              placeholder="Enter your handle"
              autoCapitalize="none"
              autoComplete="username"
              maxLength={USER_HANDLE_MAX_LENGTH}
              minLength={USER_HANDLE_MIN_LENGTH}
              pattern="[a-zA-Z0-9_.-]+"
              onChange={(e) => handleUsernameChange(e.target.value)}
            />
          </InputGroup>
          {error !== "" && <FormErrorMessage>{error}</FormErrorMessage>}
        </FormControl>
        <FormControl id="email">
          <FormLabel>Email address</FormLabel>
          <Input
            name="email"
            type="email"
            autoComplete="email"
            required
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>
        <FormControl id="password">
          <FormLabel>Password</FormLabel>
          <Input
            type="password"
            name="password"
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </FormControl>
        <Button
          type="submit"
          colorScheme="red"
          color="white"
          size="lg"
          fontSize="md"
          isLoading={props.isSubmitting}
          isDisabled={props.isSubmitting || error !== ""}
        >
          Sign up
        </Button>
      </Stack>
    </form>
  );
};
